module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('administracao.operadores.titulos.operadores'),
      "subTitle": _vm.$t('administracao.operadores.titulos.listagemSubtitlo')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('administracao.operadores.labels.novoOperador'),
      "id": "btnNovoOperador",
      "clickFunction": _vm.newProfile
    },
    slot: "new-button"
  })], 1), _c('div', {
    attrs: {
      "id": "profiles"
    }
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.operators,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [(_vm.isLoadingData) ? _c('loading-placeholder') : _vm._e(), (!_vm.isLoadingData) ? _c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-pencil action",
          attrs: {
            "disabled": !_vm.canEditOperator(props.row.perfilAcesso),
            "title": !_vm.canEditOperator(props.row.perfilAcesso) ? _vm.$t('administracao.perfilAcesso.validacao.naoPodeEditar') : ''
          },
          on: {
            "click": function($event) {
              return _vm.edit(props.row.id)
            }
          }
        })]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "filter__email"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'email')
      }
    }
  })]), _c('template', {
    slot: "filter__nomePerfilAcesso"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'nomePerfilAcesso')
      }
    }
  })]), _c('template', {
    slot: "filter__situacao"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'situacao')
      }
    }
  })])], 2)], 1)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-35506d6d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35506d6d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/administration/operator/list.pug
// module id = 1397
// module chunks = 0